export const backendURL =
  process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:8000/';
